import TechnicalError from './TechnicalError';

export default TechnicalError;
